import { render } from "./sideNav.vue?vue&type=template&id=6b78ab65"
import script from "./sideNav.vue?vue&type=script&lang=js"
export * from "./sideNav.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__